import { useState, useEffect } from 'react'
import axios from 'axios'

const useGetStates = ({ isAbbreviation }) => {
  const [options, setOptions] = useState([])

  useEffect(() => {
    loadData()
  }, [])

  const loadData = async () => {
    const response = await axios.get(`/states/for-select/`, { params: { isAbbreviation: isAbbreviation || false } })
    setOptions(response.data || [])
  }

  return options
}

export default useGetStates
